import React from 'react';
import './ChartSkeleton.css';

const ChartSkeleton = ({ isDarkMode, message = "Loading chart data..." }) => {
  return (
    <div className={`chart-skeleton-container ${isDarkMode ? 'dark-mode' : ''}`}>
      <div className="chart-skeleton-content">
        <div className="chart-skeleton-header">
          <div className="skeleton-line skeleton-title"></div>
          <div className="skeleton-line skeleton-subtitle"></div>
        </div>
        
        <div className="chart-skeleton-body">
          {/* Chart area skeleton */}
          <div className="skeleton-chart-area">
            {/* Y-axis labels */}
            <div className="skeleton-y-axis">
              <div className="skeleton-y-label"></div>
              <div className="skeleton-y-label"></div>
              <div className="skeleton-y-label"></div>
              <div className="skeleton-y-label"></div>
              <div className="skeleton-y-label"></div>
            </div>
            
            {/* Chart grid and candles */}
            <div className="skeleton-chart-main">
              {/* Grid lines */}
              <div className="skeleton-grid-line"></div>
              <div className="skeleton-grid-line"></div>
              <div className="skeleton-grid-line"></div>
              <div className="skeleton-grid-line"></div>
              
              {/* Candle skeletons */}
              <div className="skeleton-candles">
                {Array.from({ length: 20 }).map((_, i) => (
                  <div key={i} className="skeleton-candle" style={{ animationDelay: `${i * 50}ms` }}></div>
                ))}
              </div>
            </div>
          </div>
          
          {/* X-axis labels */}
          <div className="skeleton-x-axis">
            <div className="skeleton-x-label"></div>
            <div className="skeleton-x-label"></div>
            <div className="skeleton-x-label"></div>
            <div className="skeleton-x-label"></div>
            <div className="skeleton-x-label"></div>
          </div>
        </div>
        
        {/* Loading message */}
        <div className="chart-skeleton-message">
          <div className="skeleton-spinner"></div>
          <span className="skeleton-message-text">{message}</span>
        </div>
      </div>
    </div>
  );
};

export default ChartSkeleton;

